import {
  FontIcon,
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  Stack,
  getTheme,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";

interface IPanelEliminarArchivo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  archivoId: string;
  isFolder: boolean;
}
export const PanelEliminarArchivo = (props: IPanelEliminarArchivo) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [archivoId, setarchivoId] = useState("");
  const theme = getTheme();

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
      setarchivoId(props.archivoId);
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [archivoId, props.isOpen]);

  const validarForm = () => {
    if (archivoId == null) setDisableForm(true);
    if (archivoId !== null) {
      if (archivoId) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            {props.isFolder ? "Eliminar SubGrupo" : "Eliminar Documento"}
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    [props.isOpen]
  );

  const _confirmar = () => {
    setIsSend(true);
    setDisableForm(true);
    setIsContenedor(true);
    grupoDocumentoService
      .deleteArchivo(archivoId)
      .then((res) => {
        if (res.status === 200) {
          setIsSend(false);

          if (res.data.confirmacion) {
            setIsSaccesfull(true);
            setMensaje(res.data.mensaje);
            props.onRenderTable();
            setarchivoId("");

            //Clone Panel after one second
            setTimeout(() => {
              _goback();
            }, 1000);
          } else {
            setIsError(true);
            setMensajeError(res.data.mensaje);
          }
        }
      })
      .catch((err: Error) => {
        setIsSend(false);
        setIsError(true);
        setMensajeError(
          props.isFolder
            ? "No se puedo Eliminar el Grupo"
            : "No se puedo Eliminar el Documento"
        );
      });
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Eliminar"
          texto2={"Cancelar"}
          disableButton={disableForm}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
        />
      </>
    ),
    [disableForm, props.archivoId]
  );

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setarchivoId("");
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
    >
      <>
        <br />
        {/* <pre>{JSON.stringify(archivoId, null, 2)}</pre> */}

        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}

        <div hidden={isContenedor}>
          <Stack>
            <Stack.Item
              grow={3}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginBottom: "15px",
                }}
              >
                <div>
                  <FontIcon
                    iconName="Warning"
                    style={{
                      color: theme.palette.orangeLight,
                      fontSize: 30,
                      height: 35,
                      width: 35,
                    }}
                  />
                </div>

                <div style={{ marginLeft: "15px" }}>
                  <span
                    style={{
                      fontSize: "15px",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    {props.isFolder
                      ? "¿Desea eliminar el SubGrupo?"
                      : "¿Desea eliminar el Documento?"}
                  </span>
                  <span
                    style={{
                      fontSize: "15px",
                      marginBottom: "15px",
                      display: "block",
                    }}
                  >
                    Una vez confirmado, esta acción no se podrá deshacer.
                  </span>
                </div>
              </div>
            </Stack.Item>
          </Stack>
        </div>
        <br />
        <br />
      </>
    </Panel>
  );
};
